import { render, staticRenderFns } from "./setting-outline.vue?vue&type=template&id=58575745&"
import script from "./setting-outline.vue?vue&type=script&lang=js&"
export * from "./setting-outline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58575745')) {
      api.createRecord('58575745', component.options)
    } else {
      api.reload('58575745', component.options)
    }
    module.hot.accept("./setting-outline.vue?vue&type=template&id=58575745&", function () {
      api.rerender('58575745', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/setting-outline.vue"
export default component.exports